<template>
  <div class="noise">
    <canvas id="sketch-container"></canvas>
  </div>
</template>

<script>
// import noise from "portfolio/src/noise.js";
import Phenomenon from "phenomenon-px";
import fragShader from "raw-loader!glslify-loader!../shaders/frag.glsl";

export default {
  name: "UnderlayNoise",
  mounted: function() {
    if (!this.$store.state.isMobile && this.$store.state.loaded) {
      this.noise();
    }
  },
  methods: {
    noise: function() {
      let uniforms = {
        u_time: {
          type: "float",
          value: 0.0
        },
        u_resolution: {
          type: "vec2",
          value: [window.innerWidth, window.innerHeight]
        }
      };

      function render(uniforms) {
        uniforms.u_time.value += 0.01;
        uniforms.u_resolution.value = [window.innerWidth, window.innerHeight];
      }

      Phenomenon(
        fragShader,
        uniforms,
        render,
        document.getElementById("sketch-container")
      );
    }
  }
};
</script>

<style lang="scss">
.noise {
  top: 0;
  left: 0;
  height: 100%;
  width: 100vw;
  position: fixed;
  z-index: -5;
  #sketch-container {
    width: 100%;
    height: 100%;
  }
}
</style>
